module.exports = __webpack_public_path__ + "static/HaripriyaIppili-9d76e9c0b3d679df24d2c19a4e6b80c9.jpg";